import { createHashRouter, Navigate } from "react-router-dom";
import { SignIn } from "@/routes/auth/SignIn";
import { Dashboard } from "@/routes/dashboard/Dashboard";
import { Layout } from "@/routes/Layout";
import { WorkspaceInvite } from "@/routes/workspace/WorkspaceInvite";
import { ErrorPage } from "@/shared/error-page";
import { WorkspaceProvider } from "@/shared/workspace-provider";

export const router = createHashRouter([
  { path: "/auth/signin", element: <SignIn />, errorElement: <ErrorPage /> },
  // One flow for sign-in and sign-up (an emailed code); old links land on it.
  { path: "/auth/signup", element: <Navigate to="/auth/signin" replace /> },
  { path: "/invite/:id", element: <WorkspaceInvite />, errorElement: <ErrorPage /> },
  {
    element: (
      <WorkspaceProvider>
        <Layout />
      </WorkspaceProvider>
    ),
    errorElement: <ErrorPage />,
    children: [
      { path: "/", element: <Dashboard />, errorElement: <ErrorPage /> },
      { path: "/dashboard", element: <Dashboard />, errorElement: <ErrorPage /> },
      { path: "/settings", element: <Navigate to="/" replace /> },
    ],
  },
]);
